import { render, staticRenderFns } from "./UtilidadesList.vue?vue&type=template&id=5ae2b576&"
import script from "./UtilidadesList.vue?vue&type=script&lang=js&"
export * from "./UtilidadesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports